/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import "../../../assets/css/HTML.scss"
import { DataContentContent, ILandingSection } from "../../../data/interfaces" 
import Dummy from "./Dummy"

/* Protopia Ecosystem component */
export interface IHTMLProps {
   section: ILandingSection
   data: DataContentContent 
}
const DataContent = ({data, ...props}: IHTMLProps): JSX.Element => {     
    useEffect(() => {
        addCSSClass(
            `landing-data-content-${props.section.id}`,
            `.landing-data-content-${props.section.id} {
                
            }
            `
        )
        
        return () => {
            removeCSSClass(`landing-data-content-${props.section.id}`)
        }
    },[ ])
  
    return <div className={`pe-data-content-container landing-content-container`} data-type={data.type} data-content-id={data.id}>       
        <Dummy {...{ 
            ...{
                data: {
                    ...data,
                    commentary: "This component not exists. Use section's nest",
                    className: ` ${data.className} landing-data-content-${props.section.id} `
            },
            }, 
            ...props 
        }} />
    </div>
}
export default DataContent